(function () {
  'use strict';

  function hasConsent() {
    return window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() || false;
  }

  var DEBUG_KEY = 'duskCsqDebug';
  var debugOn = false;

  try {
    var debugParam = new URLSearchParams(window.location.search).get('csq_debug');
    if (debugParam === '1') sessionStorage.setItem(DEBUG_KEY, '1');
    if (debugParam === '0') sessionStorage.removeItem(DEBUG_KEY);
    debugOn = sessionStorage.getItem(DEBUG_KEY) === '1';
  } catch (e) {
  }

  var DEBUG_STYLE = 'background:#474546;color:#fff;padding:1px 5px;border-radius:3px';

  var sentCVars = {};
  var sentDVars = {};
  var sentEvents = [];

  function pushUxa(args) {
    window._uxa = window._uxa || [];
    window._uxa.push(args);

    if (args[0] === 'setCustomVariable') sentCVars[args[1]] = args[3];
    else if (args[0] === 'trackDynamicVariable') sentDVars[args[1].key] = args[1].value;
    else sentEvents.push(args[0]);

    if (!debugOn) return;

    if (args[0] === 'setCustomVariable') {
      console.log('%cCSQ CVAR ' + args[1] + '%c ' + args[2] + ' = ' + JSON.stringify(args[3]), DEBUG_STYLE, '');
    } else if (args[0] === 'trackDynamicVariable') {
      console.log('%cCSQ DVAR%c ' + args[1].key + ' = ' + JSON.stringify(args[1].value), DEBUG_STYLE, '');
    } else {
      console.log('%cCSQ%c ' + args[0], DEBUG_STYLE, '', args.slice(1));
    }
  }

  function findLatestDataLayerEvent(eventName) {
    var dl = window.dataLayer || [];
    for (var i = dl.length - 1; i >= 0; i--) {
      if (dl[i] && dl[i].event === eventName) {
        return dl[i];
      }
    }
    return null;
  }

  // One wrapper, many listeners — a one-shot restore unhooks the others.
  var dataLayerListeners = {};
  var dataLayerHooked = false;

  function onDataLayerEvent(eventName, callback) {
    (dataLayerListeners[eventName] = dataLayerListeners[eventName] || []).push(callback);
    if (dataLayerHooked) return;
    dataLayerHooked = true;

    window.dataLayer = window.dataLayer || [];
    var orig = window.dataLayer.push;
    window.dataLayer.push = function () {
      var result = orig.apply(this, arguments);
      for (var i = 0; i < arguments.length; i++) {
        var item = arguments[i];
        var listeners = item && item.event && dataLayerListeners[item.event];
        if (listeners) {
          listeners.slice().forEach(function (cb) { cb(item); });
        }
      }
      return result;
    };
  }

  function initShopifyDVars() {
    var shopify = window.Shopify || {};
    pushUxa(['trackDynamicVariable', { key: 'themeId',  value: String(window.shopifyThemeId || '') }]);
    pushUxa(['trackDynamicVariable', { key: 'locale',   value: shopify.locale || '' }]);
    pushUxa(['trackDynamicVariable', { key: 'currency', value: (shopify.currency && shopify.currency.active) || '' }]);
    pushUxa(['trackDynamicVariable', { key: 'country',  value: window.shopifyCountry || '' }]);
  }

  function fireDVars(userType) {
    pushUxa(['trackDynamicVariable', {
      key: 'visitorType',
      value: (userType === 'member') ? 'member' : 'guest'
    }]);
    pushUxa(['trackDynamicVariable', {
      key: 'userType',
      value: userType || 'visitor'
    }]);
  }

  function resolveCustomer() {
    var el = document.querySelector('[data-csq-customer-data]');
    return (el && parseJsonBlock(el, 'customer data')) || {};
  }

  function resolveUserType() {
    return resolveCustomer().userType || 'visitor';
  }

  function initDVars() {
    fireDVars(resolveUserType());
  }

  var loxaEligible = 'not_eligible';

  function parseJsonBlock(el, label) {
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      console.error('CSQ: could not parse ' + label, e);
      return null;
    }
  }

  // Quick add clones the whole main-product section into its modal, this block
  // with it — the product slots must keep describing the PDP, not the modal.
  function productDataEl() {
    var els = document.querySelectorAll('[data-csq-product-data]');
    for (var i = 0; i < els.length; i++) {
      if (!els[i].closest('quick-add-modal')) return els[i];
    }
    return null;
  }

  function resolveProductVariant() {
    var el = productDataEl();
    if (!el) return null;

    var data = parseJsonBlock(el, 'product attribute data');
    if (!data) return null;

    var variants = data.variants || {};
    var input = (el.closest('product-info') || document)
      .querySelector('form[data-type="add-to-cart-form"] input[name="id"]');
    var variantId = input ? String(input.value) : '';

    // Mid colour-swap the picker and this block can disagree — prefer this product's first variant.
    if (!variants[variantId]) {
      variantId = Object.keys(variants)[0];
      if (!variantId) return null;
    }

    return { data: data, variantId: variantId };
  }

  function resolveCart() {
    var el = document.querySelector('[data-csq-cart-data]');
    var data = el && parseJsonBlock(el, 'cart data');
    return data && typeof data.itemCount === 'number' ? data : null;
  }

  // Slot mapping lives in csq-pageview-cvars, which queues the page's values before the natural pageview.
  function liveCVars() {
    var api = window.duskCsqCVars;
    if (!api) return [];
    var product = resolveProductVariant();
    return api.product(product && product.data, product && product.variantId)
      .concat(api.cart(resolveCart()));
  }

  // Custom vars only ride the next pageview, so the bag's go out just before the popin's.
  function pushPopinCVars() {
    liveCVars().forEach(function (c) {
      // nextPageOnly keeps the bag off the pageview that fires when it closes.
      pushUxa(['setCustomVariable', c[0], c[1], c[2], c[0] >= 12 ? 'nextPageOnly' : 3]);
    });
  }

  function pushLoxaDVar() {
    pushUxa(['trackDynamicVariable', { key: 'productLoxaEligible', value: loxaEligible }]);
  }

  // Dynamic vars send immediately, unlike custom vars, so the late Loxa offer can still be attributed to this page.
  function initLoxaDVar() {
    if (!productDataEl()) return;

    if (findLatestDataLayerEvent('loxa_offer_available')) loxaEligible = 'eligible';
    pushLoxaDVar();

    onDataLayerEvent('loxa_offer_available', function () {
      loxaEligible = 'eligible';
      pushLoxaDVar();
    });

    document.addEventListener('colorVariantChanged', function (event) {
      if (!event.detail || event.detail.isQuickAdd) return;
      loxaEligible = 'not_eligible';
      pushLoxaDVar();
    });
  }

  function fireMiniBagOpen() {
    pushPopinCVars();
    pushUxa([
      'setQuery',
      window.location.search + (window.location.search ? '&' : '?') + 'cs-popin-mini-bag',
      { lifespan: 'onNextPageviewOnly' }
    ]);
    pushUxa([
      'trackPageview',
      window.location.pathname + window.location.hash.replace('#', '?__'),
      { lifespan: 'onNextPageviewOnly' }
    ]);
  }

  function fireMiniBagClose() {
    pushUxa([
      'trackPageview',
      window.location.pathname + window.location.hash.replace('#', '?__')
    ]);
  }

  function initMiniBagPageview() {
    var cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer) return;

    var originalOpen = cartDrawer.open.bind(cartDrawer);
    cartDrawer.open = function (triggeredBy) {
      fireMiniBagOpen();
      return originalOpen(triggeredBy);
    };

    var originalClose = cartDrawer.close.bind(cartDrawer);
    cartDrawer.close = function () {
      fireMiniBagClose();
      return originalClose();
    };
  }

  function fireAddToCart(sku) {
    pushUxa(['trackPageEvent', 'addToCart']);
    pushUxa([
      'ec:cart:add',
      {
        sku: sku || '',
        merchant: window.location.hostname
      }
    ]);
  }

  function initAddToCart() {
    document.addEventListener('csq:addToCart', function (event) {
      var sku = event.detail && event.detail.sku ? event.detail.sku : '';
      fireAddToCart(sku);
    });
  }

  function initIdentify() {
    var customer = resolveCustomer();
    if (customer.userType !== 'member' || !customer.customerId) return;
    pushUxa(['identify', String(customer.customerId)]);
  }

  window.duskCsq = {
    debug: function (on) {
      debugOn = on !== false;
      try {
        if (debugOn) sessionStorage.setItem(DEBUG_KEY, '1');
        else sessionStorage.removeItem(DEBUG_KEY);
      } catch (e) {
      }
      return debugOn;
    },

    vars: function () {
      var userType = resolveUserType();
      return {
        consent: hasConsent(),
        dvars: {
          themeId:     String(window.shopifyThemeId || ''),
          locale:      (window.Shopify && window.Shopify.locale) || '',
          currency:    (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || '',
          country:     window.shopifyCountry || '',
          visitorType: userType === 'member' ? 'member' : 'guest',
          userType:    userType
        },
        cvars: liveCVars().reduce(function (out, c) {
          out[c[0] + ' ' + c[1]] = c[2];
          return out;
        }, {}),
        loxaEligible: loxaEligible
      };
    },

    // pageview = queued in <head> for the natural pageview; popin = last pushed before a mini-bag pageview.
    table: function () {
      var api = window.duskCsqCVars;
      if (!api) {
        console.warn('CSQ: csq-pageview-cvars never ran, so the natural pageview carried no custom vars');
        return;
      }
      function show(v) { return v === undefined || v === null || v === '' ? '—' : v; }
      console.table(liveCVars().map(function (c) {
        return { slot: c[0], name: c[1], pageview: show(api.queued[c[0]]), popin: show(sentCVars[c[0]]), live: show(c[2]) };
      }));
    },

    status: function () {
      var privacy = window.Shopify && window.Shopify.customerPrivacy;
      var consent = null;
      try {
        consent = privacy && privacy.currentVisitorConsent ? privacy.currentVisitorConsent() : null;
      } catch (e) {
      }

      return {
        booted: booted,
        consentNow: hasConsent(),
        customerPrivacyLoaded: !!privacy,
        visitorConsent: consent,
        consentPollExhausted: consentPollExhausted,
        sentDVars: Object.assign({}, sentDVars),
        sentEvents: sentEvents.slice(),
        signals: {
          pageviewCVars:            !!window.duskCsqCVars,
          customerBlock:            !!document.querySelector('[data-csq-customer-data]'),
          loxa_offer_available:     !!findLatestDataLayerEvent('loxa_offer_available'),
          loxaOfferInDom:           !!document.getElementById('loxa-shopify-offer'),
          loxaInclusiveOfferInDom:  !!document.getElementById('loxa-shopify-inclusive-offer'),
          productBlock:             !!document.querySelector('[data-csq-product-data]'),
          cartBlock:                !!document.querySelector('[data-csq-cart-data]')
        }
      };
    },

    blocks: function () {
      var product = productDataEl();
      var cart = document.querySelector('[data-csq-cart-data]');
      return {
        product: product ? parseJsonBlock(product, 'product attribute data') : null,
        cart: cart ? parseJsonBlock(cart, 'cart data') : null
      };
    }
  };

  if (debugOn && window.duskCsqCVars) {
    console.log('%cCSQ%c custom vars queued for the natural pageview', DEBUG_STYLE, '', window.duskCsqCVars.queued);
  }

  var booted = false;
  var consentPollExhausted = false;

  function boot() {
    if (booted || !hasConsent()) return;
    booted = true;
    initShopifyDVars();
    initDVars();
    initIdentify();
    initLoxaDVar();
    initMiniBagPageview();
    initAddToCart();
  }

  // Deferred scripts run before customerPrivacy loads, and visitorConsentCollected
  // only fires on a *new* choice — checking once meant returning visitors never booted.
  var CONSENT_POLL_INTERVAL_MS = 200;
  var CONSENT_POLL_ATTEMPTS = 50;
  var CONSENT_POLL_SLOW_MS = 5000;
  var CONSENT_POLL_SLOW_ATTEMPTS = 12;

  function bootWhenConsented(attempts, interval) {
    if (booted) return;
    if (hasConsent()) {
      boot();
      return;
    }
    if (attempts > 0) {
      setTimeout(function () { bootWhenConsented(attempts - 1, interval); }, interval);
      return;
    }
    // 10s at 200ms covers a normal API load; back off rather than stop for a slow one.
    if (interval < CONSENT_POLL_SLOW_MS) {
      bootWhenConsented(CONSENT_POLL_SLOW_ATTEMPTS, CONSENT_POLL_SLOW_MS);
      return;
    }
    consentPollExhausted = true;
  }

  function startConsentPoll() {
    bootWhenConsented(CONSENT_POLL_ATTEMPTS, CONSENT_POLL_INTERVAL_MS);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startConsentPoll);
  } else {
    startConsentPoll();
  }

  document.addEventListener('visitorConsentCollected', function () {
    boot();
  });

})();
